import httpRequest from '../httpRequest'

export default {
  // 黑名单列表
  getBlackMobileList: {
    method: 'get',
    url: '/v1/cms/BlackMobile'
  },
  // 新增黑名单
  addBlackMobile: {
    method: 'post',
    url: '/v1/cms/BlackMobile'
  },
  // 删除黑名单
  deleteBlackMobile: {
    fn: (id) => httpRequest.post(`/v1/cms/BlackMobile/delete/${id}`)
  }
}
